// Updated ContactUs.jsx to use dynamic form submission via FormSubmit

import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaMapPin,
} from "react-icons/fa";
import { FaPhone, FaEnvelopeOpen } from "react-icons/fa";
import { Footer, Header, Loader } from "../components";
import Aos from "aos";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

const officeLocations = [
  {
    id: 1,
    name: "San Francisco Office",
    lat: 37.7892,
    long: -122.4011,
    address: "",
  },
  // {
  //   id: 2,
  //   name: "Texas Office",
  //   lat: 38.8924,
  //   long: -104.747,
  //   address: "",
  // },
];

const contactDetails = [
  {
    icon: <FaEnvelopeOpen />,
    title: "Email",
    details: "support@arqelio.com",
    link: "mailto:support@arqelio.com",
  },
  {
    icon: <FaPhone />,
    title: "Phone",
    details: ["(310)-736-3873"],
    link: ["tel:(310)-736-3873"],
  },
  {
    icon: <FaMapPin />,
    title: "Address",
    details: "PO Box 10536 San Francisco, CA 94086",
    link: "https://www.google.com/maps/place/ChIJQ8r9QWJ_j4ARg051K3_nB4w",
    linkLabel: "Attention Mail Office",
  },
  // {
  //   icon: <FaMapPin />,
  //   title: "Address",
  //   details: "",
  //   link: "https://www.google.com/maps/place",
  //   linkLabel: "Our Office",
  // },
];

const formDetails = [
  { name: "name", type: "text", placeholder: "Your Name" },
  { name: "email", type: "email", placeholder: "Your Valid Email Address" },
  { name: "phoneNumber", type: "tel", placeholder: "Phone Number" },
];

const socialMedia = [
  { icon: <FaFacebook />, link: "https://facebook.com" },
  { icon: <FaTwitter />, link: "https://x.com" },
  { icon: <FaLinkedin />, link: "https://linkedin.com" },
  { icon: <FaInstagram />, link: "https://instagram.com" },
];

const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [showSuccess, setShowSuccess] = useState(false); // ✅ Added success message state

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleInputChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <>
      <Header />
      <div className="flex justify-center py-4">
        <img src="/logo.png" alt="company logo" className="w-24 h-auto" />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="bg-gradient-to-r from-indigo-600 to-[#20313F] text-white py-16 text-center">
            <h2
              className="text-3xl sm:text-4xl font-semibold"
              data-aos="fade-up"
            >
              Get in Touch With Us
            </h2>
            <p
              className="text-lg sm:text-xl mt-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Have any questions?, We're here to help! Reach out to us below.
            </p>
          </section>

          <section className="py-16 bg-gray-300 text-center">
            <h2
              className="text-3xl sm:text-4xl font-semibold text-gray-900"
              data-aos="fade-up"
            >
              Arqelio LLC
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-8">
              {contactDetails.map((detail, index) => (
                <div
                  key={index}
                  className="bg-white shadow-lg p-6 rounded-lg hover:shadow-2xl transition-all duration-300"
                  data-aos="fade-up"
                  data-aos-delay={600 + index * 200}
                >
                  <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center justify-center">
                    <span className="mr-2 text-[#29313f]">{detail.icon}</span>{" "}
                    {detail.title}
                  </h3>
                  {Array.isArray(detail.details) ? (
                    detail.details.map((line, i) => (
                      <p key={i} className="text-gray-700">
                        <a href={detail.link[i]} className="hover:underline">
                          {line}
                        </a>
                      </p>
                    ))
                  ) : (
                    <p className="text-gray-700">
                      {detail.link ? (
                        <a href={detail.link} className="hover:underline">
                          {detail.details}
                        </a>
                      ) : (
                        detail.details
                      )}
                    </p>
                  )}
                  <p className="text-xl font-bold text-blue-900">
                    {detail.link && (
                      <a href={detail.link} className="hover:underline">
                        {detail.linkLabel}
                      </a>
                    )}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="py-16 bg-gray-600">
            <h2
              className="text-3xl sm:text-4xl font-semibold text-center text-gray-900"
              data-aos="fade-up"
            >
              Office Locations
            </h2>
            <div className="w-full h-96 mt-8">
              <MapContainer
                center={[37.7892, -122.4011]}
                zoom={5}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {officeLocations.map((office) => (
                  <Marker
                    key={office.id}
                    position={[office.lat, office.long]}
                    icon={
                      new L.Icon({
                        iconUrl: require("leaflet/dist/images/marker-icon.png"),
                        iconSize: [25, 41],
                        iconAnchor: [12, 41],
                      })
                    }
                  >
                    <Popup>
                      {office.name} <br /> {office.address}
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </section>

          {/* The form area */}
          <section className="py-6 bg-gray-50 text-center">
            <h2
              className="text-3xl sm:text-4xl font-semibold text-gray-900"
              data-aos="fade-up"
            >
              Send Us A Message
            </h2>

            <form
              action="https://formsubmit.co/pickuptools@gmail.com"
              method="POST"
              className="max-w-lg mx-auto bg-white p-8 mt-8 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              onSubmit={() => setShowSuccess(true)} // ✅ Triggers success message
            >
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <input
                type="hidden"
                name="_subject"
                value="New Contact Message"
              />
              <input type="hidden" name="_next" value="/contact-success" />{" "}

              {/* ✅ Optional redirect */}
              {formDetails.map((input, index) => (
                <div key={index} className="mb-6">
                  <input
                    type={input.type}
                    name={input.name}
                    placeholder={input.placeholder}
                    value={formData[input.name]}
                    onChange={handleInputChange}
                    required
                    className="w-full p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-[#29313f]"
                  />
                </div>
              ))}

              {/* The text area */}
              <div className="mb-6">
                <textarea
                  name="message"
                  placeholder="How may we help you?"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="5"
                  required
                  className="w-full p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-[#29313f]"
                />
              </div>

              <button
                type="submit"
                className="px-6 py-3 bg-[#29313f] text-white font-semibold rounded-lg hover:bg-[#1f2633] hover:scale-105 transition-transform"
              >
                Send Message
              </button>
              
              {showSuccess && (
                <div className="mt-6 p-4 text-center text-green-800 bg-green-100 border border-green-300 rounded-lg">
                  Thank you! Your message has been sent.
                </div>
              )}{" "}
              {/* ✅ Success confirmation */}
            </form>
          </section>

          <section className="py-16 bg-[#29313f] text-white text-center">
            <h2
              className="text-3xl sm:text-4xl font-semibold"
              data-aos="fade-up"
            >
              Let's Hear From You
            </h2>
            <div className="flex justify-center space-x-6 mt-6">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.link}
                  className="text-4xl transition-transform hover:scale-110"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </section>

          <Footer />
        </>
      )}
    </>
  );
};

export default ContactUs;
